// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.save-status_save-now_Bkubw {
    cursor: pointer;
    padding: 0 0.5rem;
    height: 100%;
    display: flex;
    align-items: center;
}

.save-status_save-now_Bkubw:hover {
    background-color: var(--ui-black-transparent);
}
`, "",{"version":3,"sources":["webpack://./src/components/menu-bar/save-status.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;IACI,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,6CAA6C;AACjD","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.save-now {\n    cursor: pointer;\n    padding: 0 0.5rem;\n    height: 100%;\n    display: flex;\n    align-items: center;\n}\n\n.save-now:hover {\n    background-color: var(--ui-black-transparent);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"save-now": `save-status_save-now_Bkubw`,
	"saveNow": `save-status_save-now_Bkubw`
};
export default ___CSS_LOADER_EXPORT___;
